import { useAppDispatch, useAppSelector } from "#store";
import { selectOperatorInvocationsByIds } from "#selectors";
import React from "react";
import { fetchOperatorInvocationFromServer } from "#store/operatorInvocations";
import { InterpretationsListing } from "#pages/results/InterpretationsListing";

type TableCardsForActionContainerProps = {
    operatorInvocationIds: number[];
};
/**
 * TODO improve class name.
 * @param action
 * @constructor
 */
export const InterpretationsListingByOperatorInvocations = ({
    operatorInvocationIds,
}: TableCardsForActionContainerProps) => {
    const dispatch = useAppDispatch();
    const operatorInvocations = useAppSelector(state =>
        selectOperatorInvocationsByIds(state, operatorInvocationIds)
    );
    React.useEffect(() => {
        operatorInvocationIds.forEach(id => {
            dispatch(fetchOperatorInvocationFromServer(id));
        });
    }, [operatorInvocationIds]);

    const interpretationIds = React.useMemo(() => {
        return operatorInvocations.flatMap(o => o.interpretations);
    }, [operatorInvocations]);

    return <InterpretationsListing interpretationIds={interpretationIds} />;
};
